(function () {
  var TAB_CLASSES = ["is-beauty", "is-well", "is-luxe"];
  // ?department= values that open a tab ("health" is the pre-rebrand name of Well)
  var DEPARTMENTS = { beauty: "beauty", well: "well", health: "well", luxe: "luxe", lux: "luxe" };

  function init(root) {
    if (!root || root.dataset.cnReady) return;
    root.dataset.cnReady = "true";

    var tabs = root.querySelectorAll("[data-cn-tab]");
    var views = root.querySelectorAll("[data-cn-view]");
    var tabChrome = root.querySelectorAll("[data-cn-for]");
    // Each department remembers its own sub view (Category / Brands / ...)
    var subviews = { beauty: "beauty-category", well: "well-category", luxe: "luxe-category" };
    var current = root.getAttribute("data-active-tab") || "beauty";

    function setSelected(list, isActive) {
      list.forEach(function (el) {
        var on = isActive(el);
        el.classList.toggle("is-active", on);
        el.setAttribute("aria-selected", on ? "true" : "false");
      });
    }

    function showView(name) {
      views.forEach(function (v) {
        v.hidden = v.getAttribute("data-cn-view") !== name;
      });
    }

    function selectTab(tab) {
      if (!subviews[tab]) return;
      current = tab;
      setSelected(tabs, function (t) {
        return t.getAttribute("data-cn-tab") === tab;
      });
      tabChrome.forEach(function (el) {
        el.hidden = el.getAttribute("data-cn-for") !== tab;
      });
      root.classList.remove.apply(root.classList, TAB_CLASSES);
      root.classList.add("is-" + tab);
      root.setAttribute("data-active-tab", tab);
      showView(subviews[tab]);
    }

    function selectSubview(chip) {
      var name = chip.getAttribute("data-cn-subview");
      var group = chip.closest("[data-cn-for]");
      var tab = group ? group.getAttribute("data-cn-for") : current;
      subviews[tab] = name;
      if (group) {
        setSelected(group.querySelectorAll("[data-cn-subview]"), function (c) {
          return c === chip;
        });
      }
      showView(name);
    }

    tabs.forEach(function (t) {
      t.addEventListener("click", function () {
        selectTab(t.getAttribute("data-cn-tab"));
      });
    });
    root.querySelectorAll("[data-cn-subview]").forEach(function (c) {
      c.addEventListener("click", function () {
        selectSubview(c);
      });
    });

    var dept = null;
    try {
      dept = DEPARTMENTS[(new URLSearchParams(window.location.search).get("department") || "").toLowerCase()];
    } catch (e) {}
    if (dept && dept !== current) selectTab(dept);

    root.querySelectorAll(".cn-layout").forEach(initLayout);
    root.querySelectorAll(".cn-brands").forEach(initBrands);
    syncBottomBar(root);
  }

  /* Sidebar <-> panel scroll-spy for one two-pane layout */
  function initLayout(layout) {
    var scroller = layout.querySelector("[data-cn-scroller]");
    var sidebar = layout.querySelector(".cn-sidebar");
    var links = layout.querySelectorAll(".cn-root-link");
    var stripLinks = layout.querySelectorAll(".cn-strip-link");
    var strip = layout.querySelector(".cn-strip");
    if (!scroller || !links.length) return;

    var lockUntil = 0;

    function activate(id) {
      var activeLink = null;
      links.forEach(function (a) {
        var on = a.getAttribute("data-cn-target") === id;
        a.classList.toggle("is-active", on);
        if (on) {
          a.setAttribute("aria-current", "true");
          activeLink = a;
        } else {
          a.removeAttribute("aria-current");
        }
      });
      if (activeLink && sidebar) keepInView(sidebar, activeLink);
      stripLinks.forEach(function (a) {
        var on = a.getAttribute("data-cn-target") === id;
        a.classList.toggle("is-active", on);
        if (on && strip) keepInView(strip, a);
      });
    }

    function keepInView(container, el) {
      var c = container.getBoundingClientRect();
      var r = el.getBoundingClientRect();
      if (container.scrollHeight > container.clientHeight) {
        if (r.top < c.top) container.scrollTop += r.top - c.top;
        else if (r.bottom > c.bottom) container.scrollTop += r.bottom - c.bottom;
      }
      if (container.scrollWidth > container.clientWidth) {
        if (r.left < c.left || r.right > c.right)
          container.scrollLeft += r.left - c.left - (c.width - r.width) / 2;
      }
    }

    Array.prototype.slice.call(links).concat(Array.prototype.slice.call(stripLinks)).forEach(function (a) {
      a.addEventListener("click", function (e) {
        // "Go to top category link" setting renders real URLs: let those navigate
        if ((a.getAttribute("href") || "").charAt(0) !== "#") return;
        var id = a.getAttribute("data-cn-target");
        var panel = document.getElementById(id);
        if (!panel) return;
        e.preventDefault();
        activate(id);
        // Ignore scroll-spy while the programmatic scroll runs
        lockUntil = Date.now() + 700;
        var top =
          panel.getBoundingClientRect().top -
          scroller.getBoundingClientRect().top +
          scroller.scrollTop;
        scroller.scrollTo({ top: top, behavior: "smooth" });
      });
    });

    // Scroll-spy: the current panel is the last one whose top has passed 30% of the scroller
    var panels = Array.prototype.slice.call(layout.querySelectorAll(".cn-panel"));
    var ticking = false;
    function spy() {
      ticking = false;
      if (Date.now() < lockUntil || !panels.length) return;
      var current = panels[0];
      if (scroller.scrollTop + scroller.clientHeight >= scroller.scrollHeight - 2) {
        current = panels[panels.length - 1];
      } else {
        var line = scroller.getBoundingClientRect().top + scroller.clientHeight * 0.3;
        for (var i = 0; i < panels.length; i++) {
          if (panels[i].getBoundingClientRect().top <= line) current = panels[i];
          else break;
        }
      }
      activate(current.id);
    }
    scroller.addEventListener(
      "scroll",
      function () {
        if (!ticking) {
          ticking = true;
          requestAnimationFrame(spy);
        }
      },
      { passive: true }
    );
  }

  function initBrands(list) {
    var input = list.querySelector("[data-cn-brand-input]");
    if (!input) return;
    var items = Array.prototype.slice.call(list.querySelectorAll(".cn-brand-item"));
    var empty = list.querySelector("[data-cn-brand-empty]");
    input.addEventListener("input", function () {
      var q = input.value.trim().toLowerCase();
      var shown = 0;
      items.forEach(function (item) {
        var match = !q || (item.getAttribute("data-brand") || "").indexOf(q) > -1;
        item.hidden = !match;
        if (match) shown++;
      });
      if (empty) empty.hidden = shown > 0;
    });
  }

  /* The floating mobile bottom bar sits over the overlay: pad scrollers so the last items stay reachable */
  function syncBottomBar(root) {
    var bar = document.querySelector(".mobile-navigation-bar");
    if (!bar) return;
    function update() {
      var r = bar.getBoundingClientRect();
      var covered = getComputedStyle(bar).display !== "none" && r.height > 0
        ? Math.max(0, window.innerHeight - r.top)
        : 0;
      root.style.setProperty("--cn-bottom", covered + "px");
    }
    update();
    if ("ResizeObserver" in window) new ResizeObserver(update).observe(bar);
    window.addEventListener("resize", update, { passive: true });
  }

  window.LolaCategoriesNav = { init: init };

  function run() {
    document.querySelectorAll(".category-navigation-page").forEach(init);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", run);
  else run();

  document.addEventListener("shopify:section:load", function (e) {
    var el = e.target.querySelector(".category-navigation-page");
    if (el) init(el);
  });
})();
